<template>
	<div class="flex flex-wrap">
		<DefaultHeading
			:size="2"
			:horizontal-line="true"
			:heading-margin="'lg:m-0'"
			class="mb-4 w-full"
		>
			At a glance
		</DefaultHeading>
		<KeyValueList :items="items" class="lg:col-count-3 mb-0 w-full">
			<template #[`value-ancap`]="slotProps">
				<CarbarRatings :ratings="props.product.ancap_rating" />
			</template>
		</KeyValueList>
	</div>
</template>

<script setup>
import DefaultHeading from '@/components/headings/DefaultHeading.vue'
import KeyValueList from '@/components/lists/KeyValueList.vue'
import CarbarRatings from '@/components/ratings/CarbarRatings.vue'

const props = defineProps({
	product: {
		type: Object,
		required: false,
	},
	usedAtAGlance: {
		type: Boolean,
		default: false,
	},
})

const items = computed(() => [
	{
		label: 'Year',
		value: props.product.year ? props.product.year : '',
	},
	{
		label: 'Transmission',
		value: props.product.transmission ? props.product.transmission : '',
	},
	{
		label: 'Seats',
		value: props.product.seat_capacity ? props.product.seat_capacity : '',
	},
	{
		label: 'Drive type',
		value: props.product.drive_type ? props.product.drive_type : '',
	},
	{
		label: 'Fuel type',
		value: props.product.fuel_type ? props.product.fuel_type : '',
	},
	{
		label: 'Engine',
		value: props.product.engine ? props.product.engine : '',
	},
	{
		label: 'Body type',
		value: props.product.body_type ? props.product.body_type : '',
	},
	{
		label: 'Colour',
		value: props.product.colour ? props.product.colour : '',
	},
	{
		label: 'ANCAP',
		value: props.product.ancap_rating ? props.product.ancap_rating : '',
	},
])

if (props.usedAtAGlance) {
	items.value.push({
		label: 'Odometer',
		value: props.product.odometer
			? `${formatOdometer(props.product.odometer)}km`
			: '',
	})
}
</script>
